export const periods = [
  "Current",
  "PTD",
  "QTD",
  "YTD",
  "Month",
  "Quarter",
  "Yearly",
  "DynamicMonth",
];

export const bases = ["LY", "Budget", "Forecast"];
export const comparisons = ["POR", "PAR"];
export const variances = ["DollarVar", "PercVar"];

export const CONSIDER_LINE_TYPES = [4, 5, 6, 7, 15];
